var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0698 0.953125H11.9305C5.37139 0.953125 0.0351562 6.28936 0.0351562 12.8485V28.9878C0.0351562 35.5469 5.37139 40.8831 11.9305 40.8831H28.0698C34.6289 40.8831 39.9652 35.5469 39.9652 28.9878V12.8485C39.9651 6.28936 34.6289 0.953125 28.0698 0.953125ZM35.9482 28.9878C35.9482 33.3388 32.4209 36.8662 28.0698 36.8662H11.9305C7.57943 36.8662 4.05211 33.3388 4.05211 28.9878V12.8485C4.05211 8.49733 7.57943 4.97008 11.9305 4.97008H28.0698C32.4209 4.97008 35.9482 8.49733 35.9482 12.8485V28.9878Z",
    fill: "url(#paint0_linear_1953_76957)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9992 10.5908C14.3047 10.5908 9.67188 15.2236 9.67188 20.9181C9.67188 26.6125 14.3047 31.2454 19.9992 31.2454C25.6937 31.2454 30.3265 26.6126 30.3265 20.9181C30.3265 15.2236 25.6937 10.5908 19.9992 10.5908ZM19.9992 27.2285C16.514 27.2285 13.6888 24.4033 13.6888 20.9181C13.6888 17.433 16.5141 14.6078 19.9992 14.6078C23.4843 14.6078 26.3096 17.433 26.3096 20.9181C26.3096 24.4032 23.4843 27.2285 19.9992 27.2285Z",
    fill: "url(#paint1_linear_1953_76957)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3499 13.1431C31.7167 13.1431 32.8248 12.0351 32.8248 10.6683C32.8248 9.30141 31.7167 8.19336 30.3499 8.19336C28.983 8.19336 27.875 9.30141 27.875 10.6683C27.875 12.0351 28.983 13.1431 30.3499 13.1431Z",
    fill: "url(#paint2_linear_1953_76957)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1953_76957",
    x1: 20.0002,
    y1: 40.7669,
    x2: 20.0002,
    y2: 1.26338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E09B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C74C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C21975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7024C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1953_76957",
    x1: 19.9992,
    y1: 40.7667,
    x2: 19.9992,
    y2: 1.26322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E09B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C74C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C21975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7024C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1953_76957",
    x1: 30.3499,
    y1: 40.7705,
    x2: 30.3499,
    y2: 1.26178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E09B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C74C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C21975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7024C4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/InstagramIcon.6cdb21784c9eb9841699d62fcee49a0d.svg";
export { ForwardRef as ReactComponent };